import categoryActions from "./categoryActions";
const allActionsCat = {
  categoryActions,
};

export default allActionsCat;
